import { computed, Ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { ILocalizedEntityType } from '@shared/models/proto/base/localized-entity'
import { Nullable } from '@shared/models/types/primary'
import {
  sessionStorageGet,
  sessionStorageHas,
  SessionStorageKeys,
} from '@shared/utils/helpers/storage/session-storage'

export const useUserLocale = (
  params: {
    removeDash?: boolean
    isGetUserLocale?: boolean
    shortVersion?: boolean
  } = {}
) => {
  const { locale } = useI18n()
  sessionStorageHas(SessionStorageKeys.Locale) &&
    (locale.value = sessionStorageGet(SessionStorageKeys.Locale))

  if (params.isGetUserLocale) {
    const deviceLang = navigator.language
    const avialableLocales = ['en', 'fr', 'es']
    const convertedDeviceLang =
      deviceLang.indexOf('-') === -1 ? deviceLang : deviceLang.split('-')[0]
    locale.value = avialableLocales.includes(convertedDeviceLang)
      ? convertedDeviceLang
      : 'en'
  }

  const parse = (name: string) => {
    return params.removeDash ? name.replace('-', '') : name
  }

  return {
    userLocale: computed(() => {
      // return locale.value === 'en' ? params.shortVersion ? locale.value : parse('en-US') : locale.value
      return locale.value === 'en' ? parse('en-US') : locale.value
    }),
  }
}

export const useLocalizedText = (
  data: Ref<Nullable<ILocalizedEntityType[]>>
) => {
  const { locale } = useI18n()
  const { userLocale } = useUserLocale()

  const text = computed(() => {
    return (
      (
        data?.value?.find((item) => item.locale === locale.value) ||
        data?.value?.find((item) => item.locale === userLocale.value)
      )?.value || ''
    )
  })

  return {
    text,
  }
}
